import { WorkerService } from './../../services/worker.service';
import { Component, inject, OnInit } from '@angular/core';

// NgRx
import { Store } from '@ngrx/store';
import { selectIsLoadingLogo, selectLogo } from '@store/selectors';

import { ThemeService } from '../../services';
import { LogoService } from '@core/services';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Cookies } from 'typescript-cookie';

@Component({
  templateUrl: './home-page.component.html',
  styles: [],
  standalone: true,
  imports: [ToolbarComponent, MatCardModule, NgIf, MatFormFieldModule],
})
export class HomePageComponent implements OnInit {
  public themeService = inject(ThemeService);
  private logoService = inject(LogoService);
  private readonly store = inject(Store);
  private workerService = inject(WorkerService);

  public readonly isLoading = this.store.selectSignal(selectIsLoadingLogo);
  public readonly logo = this.store.selectSignal(selectLogo);
  public readonly error = this.store.selectSignal;

  data: any;
  cookieRole = Cookies.get('role');
  ngOnInit() {
    this.chargueWorke();
  }

  chargueWorke() {
    this.workerService.getWorker().subscribe({
      next: resp => {
        if (resp.code === 10000) {
          this.data = resp.reply || {};
          console.log('datos informacion', resp);
        }
      },
    });
  }
}
